if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"subPackages","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(4(376|52|548|647)|2790|5331|5473|6126|8497)$/.test(chunkId)},
		rootOutputDir: "",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}